var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"layout-cfcsl-item",class:{'cur': _vm.itemData.choosed || _vm.choosed},on:{"click":_vm.clickItem}},[_vm._v(_vm._s(_vm.itemData.text))])}
var staticRenderFns = []

export { render, staticRenderFns }